// extracted by mini-css-extract-plugin
export default {"root":"SessionExpired_root__Lm3E-","message":"SessionExpired_message__GPppt"};